<div class="dialog-container">
    <div class="se-dialog-header">
        <h3 class="se-dialog-title" translate>AnamnesticData</h3>
    </div>

    @if (anamnesticData) {
    <mat-dialog-content class="custom-mat-dialog-content">
        <ng-container>
            <form content class="form-container">
                @if (anamnesticData.length > 1) {
                <mat-tab-group class="custom-tab-group">
                    @for ( data of anamnesticData; track data.id; let i = $index) {
                    <mat-tab [label]="getTranslatedLabel(i)">
                        <se-anamnestic-data class="standalone-custom-css" [fields]="data.anamnesticFields" [formGroup]="anamnesticDataModalForm"></se-anamnestic-data>
                    </mat-tab>
                    }
                </mat-tab-group>
                }
                @if (anamnesticData.length === 1) {
                <se-anamnestic-data class="standalone-custom-css" [fields]="anamnesticData[0].anamnesticFields" [formGroup]="anamnesticDataModalForm"></se-anamnestic-data>
                }
            </form>
        </ng-container>
    </mat-dialog-content>
    }

    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>
            {{ "Close" | translate }}
        </button>
    </mat-dialog-actions>
</div>
